import { render, staticRenderFns } from "./MemoCategory.vue?vue&type=template&id=4cf8dd6e&"
import script from "./MemoCategory.vue?vue&type=script&lang=js&"
export * from "./MemoCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports